export default "__VITE_ASSET__CugLExBo__"